import * as React from 'react';
import { SVGProps } from 'react';

const IconAddToComparisonSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M2 2h3v20H2V2zm17 0h-2v3h-3v2h3v3h2V7h3V5h-3V2zm-9 6H7v14h3V8zm2 3h3v11h-3V11zm8 3h-3v8h3v-8z" />
  </svg>
);
export default IconAddToComparisonSizeM;
